import { render, staticRenderFns } from "./LoanSchedule.vue?vue&type=template&id=23a30c4a&"
import script from "./LoanSchedule.vue?vue&type=script&lang=js&"
export * from "./LoanSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports